import type { TFunction } from "i18next";
import * as yup from "yup";
import type { AuthorizationMethod } from "../../types/authorization-method";

export const useValidationSchema = (t: TFunction, authorizationMethod?: AuthorizationMethod) => {
  const emailUserIdSchema = yup
    .string()
    .email(t("COMMONS.ERRORS.INCORRECT_EMAIL"))
    .required(t("COMMONS.ERRORS.REQUIRED"));

  return yup.object({
    userId:
      authorizationMethod === "email_authorization"
        ? emailUserIdSchema
        : yup.string().required(t("COMMONS.ERRORS.REQUIRED")),
  });
};
